export const LOOP_USER_ID_COOKIE_NAME = 'loop_user_id';

export const DEFAULT_LOOP_USER_ID = 'lm-search';

export const LOOP_USER_ID_COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year
